import script from "./SubscriptionItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionItem.vue?vue&type=style&index=0&id=e4d60656&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4d60656"]])

export default __exports__